'use strict';
namespace Reviews {

    /**
     * Service used on the mobile site to help me maintain state (i know) between the review entry and preview pages
     */
    export class ReviewPreviewStoreService {

        private review :ReviewDetails;
        private userInput :ReviewData;

        constructor() {};

        //Save the review locally
        storeReviewInfo = (review :ReviewDetails, userInput :ReviewData) :void => {
            this.review = review;
            this.userInput = userInput;
        }

        //Get the stored review if any
        getReviewDetails = () :ReviewDetails => {
            return this.review;
        }

        getUserInput = () :ReviewData => {
            return this.userInput;
        }
    }


    angular.module('reviews').service('reviewPreviewStoreService', ReviewPreviewStoreService);
}
